Object.defineProperty(exports, "__esModule", {
  value: true
});

var _and = require('./and');

var _and2 = _interopRequireDefault(_and);

var _integer = require('./integer');

var _integer2 = _interopRequireDefault(_integer);

var _nonNegativeNumber = require('./nonNegativeNumber');

var _nonNegativeNumber2 = _interopRequireDefault(_nonNegativeNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _and2['default'])([(0, _integer2['default'])(), (0, _nonNegativeNumber2['default'])()], 'nonNegativeInteger');
//# sourceMappingURL=nonNegativeInteger.js.map